import { render, staticRenderFns } from "./AccidentHistory.vue?vue&type=template&id=8b40d740&scoped=true&lang=pug&"
import script from "./scripts/AccidentHistory.js?vue&type=script&lang=js&"
export * from "./scripts/AccidentHistory.js?vue&type=script&lang=js&"
import style0 from "./AccidentHistory.vue?vue&type=style&index=0&id=8b40d740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b40d740",
  null
  
)

export default component.exports